import { widgets as productionWidgets } from './widgets.prod'
/**
 * Define which widgets are available on TEST
 */
export const widgets = [...productionWidgets]
